
































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import PicModal from '@/components/upload/picModal.vue'
import UploadOSS from '@/components/upload/index.vue'
@Component({
  components: {
    PicModal,
    UploadOSS
  }
})
export default class Video extends Vue {
  @Prop({
    type: Boolean,
    default: () => false
  })
  showDemo!: boolean

  @Prop({
    type: Object,
    default: () => {
      return {
        type: 'video',
        muted: true,
        poster: null,
        url: null
      }
    }
  })
  VideoConfig!: any

  mounted() {}

  /**
   * 选择图片
   */
  picChange(e) {
    this.VideoConfig.poster = e[0].url
  }

  /**
   * 删除图片
   */
  deleteFn() {
    this.VideoConfig.poster = null
  }

  /**
   * 选择视频
   */
  videoChange(event) {
    this.VideoConfig.url = event[0]
  }

  deleteVideo() {
    this.VideoConfig.url = null
  }
}
